var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_5013",
    x: 0,
    y: 0,
    width: 53,
    height: 53,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.078
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3537",
    "data-name": "Group 3537",
    transform: "translate(-708 -420)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 708, 420)",
    filter: "url(#Rectangle_5013)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5013-2",
    "data-name": "Rectangle 5013",
    width: 35,
    height: 35,
    rx: 5,
    transform: "translate(9 6)",
    fill: "#C2FAE5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3533",
    "data-name": "Group 3533",
    transform: "translate(731.129 437.521)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun-back-1144365_1_",
    "data-name": "noun-back-1144365 (1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12445",
    "data-name": "Path 12445",
    d: "M281.011,149.922a.891.891,0,0,0-1.259-1.259l-5.089,5.089a.891.891,0,0,0,0,1.259l5.089,5.089a.891.891,0,0,0,1.259-1.259l-4.462-4.462Z",
    transform: "translate(-274.402 -148.402)",
    fillRule: "evenodd"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeft);
export default __webpack_public_path__ + "static/media/left.2a9586b47a61e67c6583e478449aa570.svg";
export { ForwardRef as ReactComponent };